<b-overlay :show="isShow" :spinner-variant="variant" :opacity="opacity" no-fade>
  <slot></slot>
</b-overlay>